export enum ERouteName {
  ACTIVATION = "activation",
  CONSUMPTION_MONITORING = "consumption-monitoring",
  CONSUMPTION_MONITORING_SITE_DETAILS = "site-consumption-monitoring",
  DASHBOARD_MONOSITE = "dashboard-monosite",
  DASHBOARD_VIEW = "dashboard-view",
  HOME = "home",
  LOGIN = "login",
  PASSWORD_RECOVERY = "password-recovery",
  PILOTING = "piloting",
  PLANNING = "planning",
  PROGRAMMING = "programming",
  PROGRAMMING_CREATION = "programming-creation",
  PROGRAMMING_CREATION_NEW = "new-programming-creation",
  PROGRAMMING_DETAILS = "programming-details",
  PROGRAMMING_DETAILS_NEW = "new-programming-details",
  PROGRAMMING_LIST = "programming-list",
  PROGRAMMING_LIST_NEW = "new-programming-list",
  SECTION_MANAGEMENT = "section-management",
  SECTION_MANAGEMENT_NEW = "new-section-management",
  SITE_SECTIONS = "site-sections",
  SITE_SECTIONS_TREE = "site-sections-tree",
}

export const ROUTES_WITHOUT_SIDE_MENU = [ERouteName.ACTIVATION, ERouteName.LOGIN, ERouteName.PASSWORD_RECOVERY];
